<template>
   <el-dialog title="选择邮寄地址" 
      :visible.sync="addressChooseDialog" 
      :close-on-click-modal="false" 
      @close="cancleDialog"
      width="560px" >
      <el-table ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
        <el-table-column type="index" width="50">
        </el-table-column>
        <el-table-column property="name" label="姓名" width="120"></el-table-column>
        <el-table-column property="mobile" label="联系电话" width="120"></el-table-column>
        <el-table-column property="address" label="地址"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" size="small">保 存</el-button>
      </span>
   </el-dialog>
</template>
<script>
export default {
  props: ['addressChooseDialog','addressData'],
  data() {
    return {
      tableData: [],
      chooseAddressRow: null
    }
  },
  watch: {
    'addressData': {
      handler(newVal) {
        this.tableData = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.chooseAddressRow = val;
    },
    cancleDialog() {
      this.$emit('addressChoseClose')
    },
    submit() {
      this.$emit('addressChooseSend', this.chooseAddressRow)
    }
  }
}
</script>
<style lang='less' scoped>
 
 </style>